import { useGetMultiAssetValueOverview, useGetSingleAssetValueOverview } from 'ClientPortal/src/api/Queries/value-overview'
import { useGetMarketData } from 'ClientPortal/src/api/Queries/market-data'

type UseMarketDataProps = {
    coordinates?: { latitude: number; longitude: number }
    selectedAssetId?: string
}

export function useMarketData({ coordinates, selectedAssetId }: UseMarketDataProps) {
    const { multiAssetValueOverviewData, isMultiAssetValueOverviewDataPending } = useGetMultiAssetValueOverview()
    const { singleAssetValueOverview, isSingleAssetValueOverviewPending } = useGetSingleAssetValueOverview({ assetId: selectedAssetId })
    const { marketData, isMarketDataPending } = useGetMarketData({ coordinates, assetId: selectedAssetId })

    return {
        assets: multiAssetValueOverviewData?.assets || [],
        history: multiAssetValueOverviewData?.history,
        summary: multiAssetValueOverviewData?.summary,
        isAssetsPending: isMultiAssetValueOverviewDataPending,
        marketData,
        isMarketDataPending,
        selectedAsset: singleAssetValueOverview,
        isSelectedAssetPending: isSingleAssetValueOverviewPending,
    }
}
